import { render, staticRenderFns } from "./ComponentFiles.vue?vue&type=template&id=534f6668&scoped=true&"
import script from "./ComponentFiles.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ComponentFiles.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ComponentFiles.vue?vue&type=style&index=0&id=534f6668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f6668",
  null
  
)

export default component.exports